import { Component, Input, ViewContainerRef, AfterViewInit, inject } from "@angular/core";
import Lottie from "lottie-web";

@Component({
  selector: "onsip-animation",
  template: "" // no template
})
export class AnimationComponent implements AfterViewInit {
  private vcRef = inject(ViewContainerRef);

  @Input() filename!: string;
  @Input() preserveAspectRatio = "xMidYMid meet"; // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
  @Input() set loop(loop: boolean) {
    this._loop = typeof loop === "number" ? loop : loop !== undefined;
  }
  private _loop: boolean | number = false;

  ngAfterViewInit(): void {
    Lottie.loadAnimation({
      container: this.vcRef.element.nativeElement,
      renderer: "svg",
      loop: this._loop,
      autoplay: true,
      path: `resources/anim/${this.filename}.json`,
      rendererSettings: {
        preserveAspectRatio: this.preserveAspectRatio
      }
    });
  }
}
